import styled from "@emotion/styled";
import { Box, Tab, Tabs, useMediaQuery, useTheme } from "@mui/material";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { ICustomTabs } from "../interfaces/tabs";

interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: number;
    value: number;
}

const StyledTab = styled(Tab)(() => ({
    minHeight: "3em",
}));

const StyledTabs = styled(Tabs)(() => ({
    minHeight: "2em",
}));

const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tabpanel-${index}`}
            {...other}
        >
            {value === index && children}
        </div>
    );
}

const a11yProps = (index: number) => {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
    };
}

const CustomTabs: FC<ICustomTabs> = (props) => {
    const { tabs, variant } = props;
    const { t } = useTranslation();
    const [value, setValue] = useState(0);
    const theme = useTheme();
    const largeMediumScreen = useMediaQuery(theme.breakpoints.up("md"));

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ bgcolor: "background.paper" }}>
            <StyledTabs
                value={value}
                onChange={handleChange}
                textColor="inherit"
                variant={variant ? (largeMediumScreen ? variant : "scrollable") : "fullWidth"}
                aria-label="custom-tabs-labels"
            >
                {tabs.map((tab, index) => (
                    <StyledTab
                        sx={{
                            p: 1,
                            fontWeight: value === index ? 600 : 500,
                            minWidth: { sm: 164, lg: 276 },
                        }}
                        defaultValue={0}
                        key={index}
                        label={t(tab.label)}
                        {...a11yProps(index)}
                    />
                ))}
            </StyledTabs>
            {
                tabs[value] && <TabPanel value={value} index={value}>
                    {tabs[value].content}
                </TabPanel>
            }
        </Box>
    );
};

export default CustomTabs;